import { unixTs, momentObj } from '@/util/dates';
export const momentFilter = (value, format, tz) => {
    if (!value) {
        return 'Unknown data';
    }
    const date = typeof value === 'number' ? unixTs(value) : momentObj(value);
    const time = tz ? date.tz(tz) : date;
    return format ? time.format(format) : time.toString();
};
